var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1576 8.0363C10.7434 8.62208 10.7434 9.57183 10.1576 10.1576C9.57183 10.7434 8.62208 10.7434 8.0363 10.1576L5.29864 7.41996L2.56099 10.1576C1.9752 10.7434 1.02546 10.7434 0.439671 10.1576C-0.146115 9.57183 -0.146115 8.62208 0.439671 8.0363L3.17732 5.29864L0.43934 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.43934 0.43934C1.02513 -0.146447 1.97487 -0.146447 2.56066 0.43934L5.29864 3.17732L8.03663 0.43934C8.62242 -0.146447 9.57216 -0.146447 10.1579 0.43934C10.7437 1.02513 10.7437 1.97487 10.1579 2.56066L7.41996 5.29864L10.1576 8.0363Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.593f4d24f56f5d58a3de68b96335c0ea.svg";
export { ForwardRef as ReactComponent };